import CategorycardCommon from './containers/categorycardCommon'

export {default as CategorycardCommonLayout} from './components/categorycardCommonLayout'

export default CategorycardCommon
